import React from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";

const HostListData = ({ data, loading }) => {
 
  const columns = [
    {
      field: "name",
      headerName: "Name",
    },

    {
      field: "mobile",
      headerName: "Mobile",
    },
    {
        field: "pin",
        headerName: "PIN CODE",
      },
     
      {
        field: "created_at",
        headerName: "Created At",
      },

  ];

  return (
    <CTable
      columns={columns}
      data={data}
      isLoading={loading?.isLoading}
      pagination={true}
      localPagination={true}
      page={0}
      rowsPerPage={5}
    ></CTable>
  );
};

export default withRouter(HostListData);
